function initCeSlider(){
    $('.frame-type-mask_ce_img_slider .slider').slick(
        {
            arrows:false,
            dots:true,
            autoplay:true,
            fade:true,
            autoplaySpeed: 5000,
        }
    );

    $('.frame-type-mask_ce_quote_slider .quote-slider').slick(
        {
            arrows:false,
            autoplay:true,
            fade:true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 6000,
            responsive: [
                {
                    breakpoint: 1366,
                    settings: {
                        dots: false
                    }
                }
            ],
        }
    );
}